import { Flag } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Фича-флаги (БО-20): чтение — DODOC_ADMIN и DODOC_SUPPORT, изменения и журнал — DODOC_ADMIN (с аудитом). */
export const section = defineSection({
  id: 'backoffice.flags',
  area: 'backoffice',
  path: 'flags',
  roles: ['DODOC_ADMIN', 'DODOC_SUPPORT'],
  icon: Flag,
  titleKey: 'boFlags:title',
  namespaces: ['portal', 'backoffice'],
  navGroup: 'library',
  order: 200,
  load: () => import('./FlagsPage'),
});
